import React, { useCallback, useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { sortBy, unique } from 'lib/array/arrayUtils'
import Group from 'components/utils/Group'
import FilterChip from 'LuxKit/Chips/FilterChip'

interface Props {
  onSelect?: (year?: number) => void
  departureYear?: number
  departures: Array<App.Tours.TourV2OfferDeparture>
}

function TourV2DepartureYearFilters(props: Props) {
  const { onSelect, departureYear, departures } = props

  const departureYears = useMemo(() => {
    const years = unique(departures.map(dep => new Date(dep.startDate).getFullYear()))
    if (years.length === 1) {
      // The 'all departures' covers the scenario where there is only 1 year
      return []
    }
    return sortBy(years, val => val, 'asc')
  }, [departures])

  const onDepartureYearClick = useCallback<React.MouseEventHandler<HTMLButtonElement>>(e => {
    const year = e.currentTarget.dataset.year
    onSelect?.(year ? parseInt(year) : undefined)
  }, [onSelect])

  return <Group direction="horizontal" gap={4}>
    <FilterChip
      size="large"
      onClick={onDepartureYearClick}
      selected={!departureYear || departureYears.length === 0}
    >
      <FormattedMessage
        id="dJO2Ii5zJ/"
        defaultMessage="All departures"
        description="Filter chip label to show all available tour departures across all years"
      />
    </FilterChip>

    {departureYears.map(year => <FilterChip
      size="large"
      key={year}
      data-year={year}
      onClick={onDepartureYearClick}
      selected={year === departureYear}
    >
      {year}
    </FilterChip>)}
  </Group>
}

export default React.memo(TourV2DepartureYearFilters)
